import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '@core/interfaces/root-state';
import { DetailsState } from '@core/interfaces/details-state';
import { setProp, getProp } from '@shared/helpers/operators';

const state: DetailsState = {
  models: {},
  // extends with new prop and methods here
};

// Synchronous functions to get data from state (can be composed properties)
export const getters: GetterTree<DetailsState, RootState> = {
  configLoaded: state => (entity: string) => {
    return getProp(state.models, `${entity}.configLoaded`);
  },
  loadingEntity: state => (entity: string) => {
    return getProp(state.models, `${entity}.loadingEntities`);
  },
  canLoadEntity: state => payload => {
    const flags = payload.flags.map(item => getProp(state.models, `${payload.entity}.${item}`));
    return flags.every(value => value === true);
  },
};

// Asynchornous functions to get data usually from an api call
export const actions: ActionTree<DetailsState, RootState> = {};

// The vuex way of changing a state property
export const mutations: MutationTree<DetailsState> = {
  startLoadingConfig(state, entity) {
    setProp(state.models, `${entity}.configLoaded`, false);
  },
  stopLoadingConfig(state, entity) {
    setProp(state.models, `${entity}.configLoaded`, true);
  },
  startLoadingEntity(state, entity) {
    setProp(state.models, `${entity}.loadingEntity`, true);
  },
  stopLoadingEntity(state, entity) {
    setProp(state.models, `${entity}.loadingEntity`, false);
  },
  //
  clearCanLoadEntities(state, entity) {
    setProp(state.models, `${entity}.configLoaded`, false);
    setProp(state.models, `${entity}.loadingEntity`, false);
  },
};

export const DetailsStoreModule: Module<DetailsState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
